export default function Modal({ children, isLargeModal = false }) {
  return (
    <>
      <div className="p-4 bg-[#060606cf] justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div
          className={
            isLargeModal
              ? `relative m-auto w-full sm:max-w-[1000px]`
              : `relative m-auto w-full sm:max-w-[500px]`
          }
        >
          {/*content*/}
          <div
            className="box-border bg-light-blue
          dark:bg-slate-800 dark:border-gray-700
           border border-light-gray rounded-lg relative flex flex-col w-full outline-none focus:outline-none p-3 md:p-8"
          >
            {children}
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  )
}
